import { Locale } from "../../types/i18n"
import formatter from "../../i18n/format/number"

export default (locale: Locale): (n: number, decimals?: number) => string => {
	const format = formatter(locale)
	const currency = locale.currency
	const [prefix, suffix] = currency.prefix ? [currency.symbol, ""] : ["", currency.symbol]
	return (n: number, decimals: number = 2) => `${ prefix } ${ format(n, decimals) } ${ suffix }`.trim()
}
